import { FormChildQuestionDto, FormQuestionDto } from "@green0meter/api-client";
import React, { FC, memo } from "react";
import { Controller, useFormContext } from "react-hook-form";

import { FormControl, FormControlLabel, Radio, RadioGroup } from "@components/base";

interface RadioInput {
  question: FormQuestionDto | FormChildQuestionDto;
  disabled?: boolean;
}

const RadioInput: FC<RadioInput> = ({ question, disabled }) => {
  const { control } = useFormContext();

  return (
    <FormControl component="fieldset" fullWidth disabled={disabled}>
      <Controller
        name={question.code}
        control={control}
        render={({ field }) => (
          <RadioGroup {...field} row>
            {question.answerOptions?.map((option) => (
              <FormControlLabel
                key={option.id}
                control={<Radio />}
                label={option.name}
                value={option.code}
                checked={field.value === option.code}
              />
            ))}
          </RadioGroup>
        )}
      />
    </FormControl>
  );
};

export default memo(RadioInput);
